import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const MMA = () => {
  return (
    <SportsLayoutComp name={'MMA'}/>
  )
}

export default MMA